export default __webpack_public_path__ + "static/media/uipath-icon.f25989dc.svg";